import api from '@/components/mixins/baseApi';
// import { DateTime } from 'luxon';

export default {
  mixins: [api],

  methods: {
    getGallery(id) {
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        // без завершающего слеша: /gallery/{id}/ отвечает 404, а /gallery/ без id — нет
        url: `${this.$store.getters.apiBasePath}/gallery/${id ? `${id}` : ''}`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data.results;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          return Promise.reject(error);
        });
    },
  },
};
